/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Position in the resource list (0-based)
 */
export type ResourcePosition = number | null;
